"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCardsExerciseHandler = void 0;
const AbstractExerciseHandler_1 = require("@app/routes/SpeechDevelopment/handlers/AbstractExerciseHandler");
const audioPlayer_1 = require("@app/services/audioPlayer");
const exercise_js_1 = require("@app/routes/SpeechDevelopment/reducers/exercise.js");
const timer_1 = require("../exersices/Disinhibition/timer");
class DefaultCardsExerciseHandler extends AbstractExerciseHandler_1.AbstractExerciseHandler {
    constructor() {
        super(...arguments);
        this.attemptMaxNumber = 3;
    }
    get isLast() {
        return this.currentIndex === this.data.length - 1;
    }
    get isFirst() {
        return this.currentIndex === 0;
    }
    playCurrentQuestion() {
        return __awaiter(this, void 0, void 0, function* () {
            yield audioPlayer_1.audioPlayer.stopAudio();
            yield audioPlayer_1.audioPlayer.playAudio(null, this.current.full_question_audio);
        });
    }
    checkOrder(options, answers) {
        console.log('options', options);
        console.log('answers', answers);
        for (let i = 0; i < options.length; i++) {
            const hasMatch = answers.some((e) => options[i] === e);
            if (!hasMatch) {
                return false;
            }
        }
        return true;
    }
    answerOptionToWordArray(option) {
        return option
            .replace(/(?!['’-])\p{P}/gu, '')
            .toLowerCase()
            .split(' ');
    }
    extractRightAnswer(answer) {
        var _a;
        const options = [...((_a = this.current.additional_correct_words) !== null && _a !== void 0 ? _a : []), this.current.right_word].map((elem) => this.answerOptionToWordArray(elem));
        const result = options.find((option) => this.checkOrder(option, answer));
        if (!result)
            return null;
        return Array.isArray(result) ? result.join(' ') : String(result);
    }
    checkIsCorrectAnswer(answer) {
        return !!this.extractRightAnswer(answer);
    }
    handleCorrectAnswer() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            (0, timer_1.stopTimer)();
            const nextId = !this.isLast ? (_a = this.data[this.currentIndex + 1]) === null || _a === void 0 ? void 0 : _a.id : undefined;
            this.trackRepEnd(true, nextId);
            this.updateAnswers({ isCorrect: true, isChecked: true, id: this.current.id });
            yield this.addCoin();
            if (!this.isLast) {
                this.dispatch((0, exercise_js_1.setCurrentIndex)(this.currentIndex + 1));
                this.dispatch((0, exercise_js_1.resetRecognizedWords)());
                this.dispatch((0, exercise_js_1.resetUserRightAnswer)());
            }
            else {
                this.stopExercise();
            }
        });
    }
    handleWrongAnswer(timeIsOver) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            audioPlayer_1.audioPlayer.stopAudio();
            if (this.recognizedWords.length + 1 === this.attemptMaxNumber || timeIsOver) {
                if (!timeIsOver)
                    (0, timer_1.stopTimer)();
                const nextId = !this.isLast ? (_a = this.data[this.currentIndex + 1]) === null || _a === void 0 ? void 0 : _a.id : undefined;
                this.trackRepEnd(false, nextId);
                this.updateAnswers({ isCorrect: false, isChecked: true, id: this.current.id });
                yield audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(this.langId, 315));
                yield audioPlayer_1.audioPlayer.playAudio('right_audio', this.current.right_audio);
                if (this.isLast) {
                    this.stopExercise();
                    return;
                }
                this.dispatch((0, exercise_js_1.setCurrentIndex)(this.currentIndex + 1));
                this.dispatch((0, exercise_js_1.resetRecognizedWords)());
            }
            else
                yield audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(this.langId, 318));
        });
    }
    handleTimerOut() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isChecked && !this.answers[this.currentIndex])
                yield this.handleWrongAnswer(true);
        });
    }
    nextCard() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isLast)
                return;
            (0, timer_1.stopTimer)();
            this.trackRepEnd(false, (_a = this.data[this.currentIndex + 1]) === null || _a === void 0 ? void 0 : _a.id);
            this.updateAnswers({ isCorrect: false, isChecked: true, id: this.current.id });
            this.dispatch((0, exercise_js_1.resetRecognizedWords)());
            this.dispatch((0, exercise_js_1.resetUserRightAnswer)());
            this.dispatch((0, exercise_js_1.setCurrentIndex)(this.currentIndex + 1));
        });
    }
    previousCard() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isFirst)
                return;
            (0, timer_1.stopTimer)();
            this.dispatch((0, exercise_js_1.resetRecognizedWords)());
            this.dispatch((0, exercise_js_1.resetUserRightAnswer)());
            this.dispatch((0, exercise_js_1.setCurrentIndex)(this.currentIndex - 1));
            this.dispatch((0, exercise_js_1.setAnswers)(this.answers.slice(0, this.answers.length - 1)));
        });
    }
    stopExercise() {
        (0, timer_1.stopTimer)();
        this.dispatch((0, exercise_js_1.setIsSFinished)(true));
        audioPlayer_1.audioPlayer.stopAudio();
        window.stopExercise(true, true, this.exerciseInfo.id);
        this.sendExerciseReport(this.exerciseInfo.number || this.exerciseInfo.id, this.answers);
    }
    pause() {
        audioPlayer_1.audioPlayer.stopAudio();
        (0, timer_1.stopTimer)();
    }
}
exports.DefaultCardsExerciseHandler = DefaultCardsExerciseHandler;
